(function(){
  document.querySelectorAll('.mobile-nav').forEach(function(nav){
    nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){nav.removeAttribute('open');});});
  });

  document.addEventListener('click',function(e){
    var play=e.target.closest('[data-video-play]');
    if(!play) return;
    var frame=play.closest('.video-frame');
    var iframe=document.createElement('iframe');
    iframe.src=frame.dataset.embed;
    iframe.title=frame.dataset.title||'Video';
    iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen=true;
    frame.innerHTML='';
    frame.appendChild(iframe);
  });

  var lb=document.getElementById('Lightbox');
  if(!lb) return;
  var img=lb.querySelector('img'),cap=lb.querySelector('.lightbox-caption'),items=[],idx=0;
  function show(i){
    idx=(i+items.length)%items.length;
    var it=items[idx];
    img.src=it.dataset.full;img.alt=it.dataset.alt||'';
    cap.textContent=(it.dataset.alt||'')+(items.length>1?'  ·  '+(idx+1)+' / '+items.length:'');
    lb.querySelector('.lb-prev').hidden=lb.querySelector('.lb-next').hidden=items.length<2;
  }
  document.addEventListener('click',function(e){
    var it=e.target.closest('[data-lightbox]');
    if(!it) return;
    items=Array.prototype.slice.call(document.querySelectorAll('[data-lightbox="'+it.dataset.lightbox+'"]'));
    show(items.indexOf(it));
    lb.showModal();
  });
  lb.querySelector('.lb-close').addEventListener('click',function(){lb.close();});
  lb.querySelector('.lb-prev').addEventListener('click',function(){show(idx-1);});
  lb.querySelector('.lb-next').addEventListener('click',function(){show(idx+1);});
  lb.addEventListener('click',function(e){if(e.target===lb) lb.close();});
  lb.addEventListener('close',function(){img.removeAttribute('src');});
  document.addEventListener('keydown',function(e){
    if(!lb.open) return;
    if(e.key==='ArrowLeft') show(idx-1);
    if(e.key==='ArrowRight') show(idx+1);
  });
})();
